import { useTranslation } from "react-i18next";

import type { IJournalPaperTableProps } from "@/template/articlesAndBooks/journalPaper/table/types";
import { useJournalPaperListColumns } from "@/template/articlesAndBooks/journalPaper/table/columns";
import { PageTable } from "@components/organisms/pageTable";
import { path } from "@routes/path.ts";

export function JournalPaperTable(props: IJournalPaperTableProps) {
  const {
    data,
    isLoading,
    total,
    tableParamProps,
    isError,
    isFetching,
    noAction,
  } = props;
  const { t } = useTranslation(["subtitle", "common"]);
  const columns = useJournalPaperListColumns(props);

  return (
    <PageTable
      title={t("listOfPapersPublishedInMagazine")}
      placeholder={t("common:tablesSearch.publishedArticles")}
      type={"basic"}
      tableProps={{
        columnDef: columns,
        dataJSON: data,
        hasActionCell: true,
        showRow: true,
      }}
      total={total}
      isFetching={isFetching}
      isError={isError}
      isLoading={isLoading}
      action={
        noAction
          ? undefined
          : {
              label: "addPaper",
              to: path.journalPapersPath.create(),
            }
      }
      {...tableParamProps}
    />
  );
}
